import { jsx } from 'react/jsx-runtime';
import 'react';
import 'styled-components';
import '../../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import ThemedComponentWrapper from '../../../../theme/ThemedComponentWrapper.js';

function Box(rest) {
    return jsx(ThemedComponentWrapper, { name: "box", ...rest });
}

export { Box as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm94LmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9hdG9tcy9sYXlvdXQvQm94L0JveC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVGhlbWVkQ29tcG9uZW50V3JhcHBlclByb3BzIH0gZnJvbSAnLi4vLi4vLi4vLi4vdGhlbWUvVGhlbWVkQ29tcG9uZW50V3JhcHBlcic7XG5pbXBvcnQgeyBUaGVtZWRDb21wb25lbnRXcmFwcGVyIH0gZnJvbSAnQHRoZW1lJztcblxuZXhwb3J0IGludGVyZmFjZSBCb3hQcm9wcyBleHRlbmRzIFBhcnRpYWw8VGhlbWVkQ29tcG9uZW50V3JhcHBlclByb3BzPiB7fVxuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBCb3gocmVzdDogQm94UHJvcHMpIHtcbiAgcmV0dXJuIDxUaGVtZWRDb21wb25lbnRXcmFwcGVyIG5hbWU9XCJib3hcIiB7Li4ucmVzdH0gLz47XG59XG4iXSwibmFtZXMiOlsiX2pzeCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFLd0IsU0FBQSxHQUFHLENBQUMsSUFBYyxFQUFBO0lBQ3hDLE9BQU9BLEdBQUEsQ0FBQyxzQkFBc0IsRUFBQyxFQUFBLElBQUksRUFBQyxLQUFLLEVBQUEsR0FBSyxJQUFJLEVBQUEsQ0FBSSxDQUFDO0FBQ3pEOzs7OyJ9
